// Сетевые формулировки браузера на обрыве fetch / HTTP-стрима PowerSync.
//
// Это не дефект приложения. Инцидент #16: после окна 30 с группа
// `powersync.sync_error` всё равно копила повторы (58 / 19 людей). Карточка
// Hawk несла `sync_error_code: Failed to fetch`, `has_synced: true`, пустую
// очередь — и в тот же момент `studyhub-powersync` был healthy, Caddy не
// отдавал 5xx, а HEAD `/version.json` с origin SPA отвечал 200. Проба сети
// бьёт в свой origin, стрим синка — в `powersync.*`; «онлайн» и «нет стрима»
// спокойно сосуществуют (вкладка уснула, клиент закрыл стрим, смена сети).
//
// Частоту таких разрывов считает PostHog. В Hawk они не едут: событие там
// равно issue и разбору человеком, а разбирать тут нечего.

const CLIENT_NETWORK_SYNC_ERROR_RE =
	/^(failed to fetch|network error|load failed|network request failed|fetch failed|the internet connection appears to be offline|networkerror when attempting to fetch resource)$/i;

export function isClientNetworkSyncError(code: string | null | undefined): boolean {
	if (!code) return false;
	return CLIENT_NETWORK_SYNC_ERROR_RE.test(code.trim());
}
